import { Component, Inject, OnDestroy, OnInit, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppErrorsService } from 'app/frontend/lib/admin/app-errors/app-errors.service';
import { BouncesService } from 'app/frontend/lib/admin/bounces/bounces.service';
import { UserService } from 'app/frontend/lib/shared/util/user';
import { Subject, distinctUntilChanged, firstValueFrom, map, takeUntil, tap } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';


@Component({
    selector: 'admin-main',
    templateUrl: './admin-main.component.html',
    styleUrls: ['./admin-main.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdminMainComponent implements OnInit, OnDestroy {

  loadingBarColor = getComputedStyle(this.document.body).getPropertyValue('--tm-green').toString()

  toggleNav: boolean = true;
  bouncesNumber: number;
  apperrorsNumber: number;
  devMode: boolean;

  private _destroy$ = new Subject<void>();

  protected isHandset$ =  this.breakpointObserver.observe([
    Breakpoints.Handset
  ]).pipe(
      map(result => result.matches),
      distinctUntilChanged()
  )

  constructor(
    private http: HttpClient, 
    private userService: UserService, 
    private appErrorsService: AppErrorsService, 
    private bouncesService: BouncesService, 
    private breakpointObserver: BreakpointObserver,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  async ngOnInit() {
    await this._headerCounts();
    await this._isDev();

    this.appErrorsService.appErrorsNumber$.pipe(
      tap(apperrorsNumber => {
        this.apperrorsNumber = apperrorsNumber;
      }),
      takeUntil(this._destroy$)
    ).subscribe()

    this.bouncesService.bouncesNumber$.pipe(
      tap(bouncesNumber => {
        this.bouncesNumber = bouncesNumber;
      }),
      takeUntil(this._destroy$)
    ).subscribe()
  }

  ngOnDestroy() { 
    this._destroy$.next();
    this._destroy$.complete();
  }

  private async _headerCounts() {
    const response = await firstValueFrom(this.http.get<{ bounces_count: number, apperrors_count: number }>(`/admin/header/counts`));
    this.bouncesNumber = response.bounces_count;
    this.apperrorsNumber = response.apperrors_count;
  }

  private async _isDev() {
    const user = await this.userService.get()
    this.devMode = user.isDev;
  }
}